requestAnimationFrame(() => {
  scriptController.executeWhenScriptLoaded(['modal-opener.js'], () => {
    themeBase.onDOMContentLoadedTrigger(() => {
      if (!customElements.get('navigation-drawer')) {
        class NavigationDrawer extends ModalDialog {
          constructor() {
            super();

            this.mainDetailsToggle = this.querySelector('details');
            this.buttonBack = document.querySelector('.js-menu-drawer-back');
            this.modalOverlay = this.querySelector('.modal-overlay');
            this.menuDrawer = document.querySelector('#menu-drawer');
            this.inner = document.querySelector('.mobile-facets__inner');
            delegate(this, 'click', 'summary', this.onSummaryClick.bind(this));
            delegate(this, 'click', '.js-navigation-drawer-back', this.onCloseButtonClick.bind(this));
            delegate(this, 'click', 'a[href*="#"]', this.onAnchorLinkClick.bind(this));
          }

          show() {
            super.show(...arguments);
          }

          hide(callback) {
            this.resetDrawerDetailsState();
            document.body.classList.remove('body-menu-opening');
            themeBase.unfreezeScroll();
            super.hide(callback);
          }

          resetDrawerDetailsState() {
            this.querySelectorAll('details').forEach((detailsElement) => {
              detailsElement.removeAttribute('open');
              detailsElement.classList.remove('menu-opening');

              const summaryElement = detailsElement.querySelector(':scope > summary');
              if (summaryElement) {
                summaryElement.setAttribute('aria-expanded', false);
              }
            });

            this.checkMenuState();
          }

          isTopLevelDetails(detailsElement) {
            if (this.tagName !== 'NAVIGATION-DRAWER') {
              return detailsElement === this.mainDetailsToggle;
            }
            return detailsElement?.parentElement?.classList.contains('menu-drawer__first-level') || false;
          }

          onSummaryClick(event) {
            const summaryElement = event.target.closest('summary');
            const detailsElement = summaryElement?.parentNode;
            if (!summaryElement || !detailsElement) return;

            const isOpen = detailsElement.hasAttribute('open');
            const reducedMotion = {
              matches: false
            };

            function addTrapFocus() {
              trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
              summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
            }

            if (this.isTopLevelDetails(detailsElement)) {
              if (isOpen) event.preventDefault();
              isOpen ? this.closeMenuDrawer(event, summaryElement, detailsElement) : this.openMenuDrawer(summaryElement, detailsElement);
            } else {
              setTimeout(() => {
                detailsElement.classList.add('menu-opening');
                summaryElement.setAttribute('aria-expanded', true);
                !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
                this.checkMenuState();
              }, 100);
            }
          }

          checkMenuState() {
            this.classList.toggle('has-opened-menu', this.querySelectorAll('.menu-opening').length > 0);
          }

          openMenuDrawer(summaryElement, detailsElement) {
            if (this.inner) {
              this.inner.removeEventListener('transitionend', this.onCloseTransitionend);
            }

            setTimeout(() => {
              detailsElement.classList.add('menu-opening');
            }, 100);
            summaryElement.setAttribute('aria-expanded', true);
            trapFocus(detailsElement, summaryElement);

            themeBase.freezeScroll({
              breakpoint: this.dataset.breakpoint,
              additionalClass: 'body-menu-opening'
            });
          }

          onCloseTransitionend() {
            document.body.classList.remove('body-menu-opening');
          }

          closeMenuDrawer(event, elementToFocus = false, detailsElement = null) {
            if (event !== undefined) {
              if (this.inner) {
                this.inner.removeEventListener('transitionend', this.onCloseTransitionend);
                this.inner.addEventListener('transitionend', this.onCloseTransitionend, {
                  once: true
                });
              }

              if (detailsElement) {
                detailsElement.classList.remove('menu-opening');
                detailsElement.querySelectorAll('details').forEach(details => {
                  details.removeAttribute('open');
                  details.classList.remove('menu-opening');
                });
              }
              removeTrapFocus(elementToFocus);
              if (detailsElement) {
                this.closeAnimation(detailsElement);
              } else {
                this.resetDrawerDetailsState();
              }
            }
            themeBase.unfreezeScroll();
          }

          onCloseButtonClick(event) {
            const detailsElement = event.target.closest('details');
            const summaryElement = detailsElement.querySelector('summary');

            summaryElement.focus();
            this.closeSubmenu(detailsElement);
            this.checkMenuState();
          }

          onAnchorLinkClick(event) {
            const link = event.target.closest('a[href*="#"]');
            if (!link) return;

            const url = new URL(link.href, window.location.href);
            if (url.pathname !== window.location.pathname || url.search !== window.location.search || !url.hash) return;

            event.preventDefault();
            let anchorHandled = false;
            const scrollToAnchor = () => {
              if (anchorHandled) return;
              anchorHandled = true;

              if (window.themeAnchorLinks?.scrollToLink) {
                window.themeAnchorLinks.scrollToLink(link);
              }
            };

            this.hide(() => {
              scrollToAnchor();
            });
            setTimeout(scrollToAnchor, 450);
          }

          closeSubmenu(detailsElement) {
            detailsElement.classList.remove('menu-opening');
            detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
            removeTrapFocus();
            this.closeAnimation(detailsElement);
          }

          closeAnimation(detailsElement) {
            let animationStart;

            const handleAnimation = (time) => {
              if (animationStart === undefined) {
                animationStart = time;
              }

              const elapsedTime = time - animationStart;

              if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
              } else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) {
                  trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
              }
            }

            window.requestAnimationFrame(handleAnimation);
          }
        }

        scriptController.onStyleReady(() => {
          window.NavigationDrawer = NavigationDrawer;
          customElements.define('navigation-drawer', NavigationDrawer);
          scriptController.scripts.push('navigation-drawer.js');
        }, ['component-navigation-drawer']);

        if (!customElements.get('facets-drawer')) {
          class FacetsDrawer extends NavigationDrawer {
            constructor() {
              super();
            }
          }

          scriptController.onStyleReady(() => {
            customElements.define('facets-drawer', FacetsDrawer);
          }, ['component-facets']);
        }
      }
    });
  });
});
